import { render, staticRenderFns } from "./FixBasket.vue?vue&type=template&id=71a370bb&scoped=true"
import script from "./FixBasket.vue?vue&type=script&lang=js"
export * from "./FixBasket.vue?vue&type=script&lang=js"
import style0 from "./FixBasket.vue?vue&type=style&index=0&id=71a370bb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a370bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a370bb')) {
      api.createRecord('71a370bb', component.options)
    } else {
      api.reload('71a370bb', component.options)
    }
    module.hot.accept("./FixBasket.vue?vue&type=template&id=71a370bb&scoped=true", function () {
      api.rerender('71a370bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FixBasket.vue"
export default component.exports